import React, { Component } from "react";
import { Link } from "react-router-dom";

class AFColumnTestimonial extends Component {
  testimonialSectionRef = React.createRef();
  hasScrolledToMissingTestimonial = false;

  componentDidMount = () => {
    require("./print.scss");
    if (this.props.fromEditor) {
      require("./editor.scss");
    }
    this.scrollToMissingTestimonialIfNeeded();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.testimonials !== this.props.testimonials) {
      this.scrollToMissingTestimonialIfNeeded();
    }
  }

  isMissingTestimonials = () => {
    const { testimonials } = this.props;
    return (
      testimonials === "none" ||
      testimonials === null ||
      !testimonials ||
      !testimonials.testimonialContent
    );
  };

  scrollToMissingTestimonialIfNeeded = () => {
    const { fromEditor } = this.props;
    if (
      !fromEditor ||
      this.hasScrolledToMissingTestimonial ||
      !this.isMissingTestimonials()
    ) {
      return;
    }

    this.hasScrolledToMissingTestimonial = true;
    // Parent PMA pages scroll to top on mount; wait so we land on this section.
    window.setTimeout(() => {
      if (this.testimonialSectionRef.current) {
        this.testimonialSectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 400);
  };

  render() {
    const {
      testimonials,
      agentData,
      fromEditor,
      currentArea,
      tallerStyles,
      showAllEditButtons,
    } = this.props;
    let testimonialContentRowStyles = "";

    const { mlsAreaID } = currentArea;
    const { listgenUserID } = agentData;
    let showButton = fromEditor && showAllEditButtons;
    let showTitle = true;
    const rootClassName = `print-april-2023-af-column-testimonial${
      fromEditor ? " editor-april-2023-af-column-testimonial" : ""
    }`;
    if (listgenUserID === "100462") {
      testimonialContentRowStyles = "af-column-testimonial-content-row-mt-19";
    }
    if (listgenUserID === "102843") {
      showTitle = false;
    }
    if (
      testimonials === "none" ||
      testimonials === null ||
      !testimonials ||
      !testimonials.testimonialContent
    ) {
      return (
        <div
          ref={this.testimonialSectionRef}
          className={`${rootClassName} af-column-testimonial-no-testimonial-available`}
        >
          {fromEditor && (
            <Link to="/agent/clienttestimonials">
              <div className="af-column-testimonial-text-container">
                <div className="af-column-testimonial-content-row">
                  <div className="af-column-testimonial-add-text">
                    Please add at least one client Testimonial to your profile
                    page.
                  </div>
                  <div className="af-column-testimonial-add-text">
                    {" "}
                    Click HERE!
                  </div>
                </div>
              </div>
            </Link>
          )}
        </div>
      );
    } else {
      let { clientFirstName, clientLastName, testimonialContent } =
        testimonials;
      if (mlsAreaID === "CCA-4500M") {
        testimonialContent =
          "Exceeded all expectations! Sue Rubin and Mike O’Brien are outstanding listing agents. Their work and Concierge Services helped my home sell for 14% over list price, setting a record for my model. They truly increase equity and resale values. Hands down, they are the community’s trusted real estate team and partner in profit.";
        clientFirstName = "Crow Canyon";
        clientLastName = "Seller";
      }
      // if (listgenUserID === "102843") {
      //   testimonialContent =
      //     "I have nothing but praise for Michael Galli and his excellent team. They are thorough, attentive, efficient and prompt—all things that you want when you are planning to buy or sell your house.";
      //   if (mlsAreaID === "SCL-209A") {
      //     clientFirstName = "Recent Cuesta Park Sellers";
      //     clientLastName = "— June 19";
      //   } else {
      //     clientFirstName = "Recent Mountain View Sellers";
      //     clientLastName = "— June 19";
      //   }
      // }

      const testimonialLength = testimonialContent.length;
      let testimonialTextStyles;
      let testimonialContainerStyles;
      let signoffStyles;
      if (listgenUserID === "106024") {
        testimonialTextStyles = "af-column-testimonial-text-14";
      } else if (testimonialContent && testimonialLength > 400) {
        testimonialTextStyles = "af-column-testimonial-medium-text";
      } else if (listgenUserID === "102843") {
        testimonialTextStyles = "af-column-testimonial-text-19";
      } else if (listgenUserID === "100462") {
        testimonialTextStyles = "af-column-testimonial-width-93";
      }

      // if (tallerStyles) {
      //   testimonialContainerStyles = "af-column-testimonial-taller";
      // }
      let clientNameLength = 0;
      if (clientFirstName && clientLastName) {
        clientNameLength =
          (clientFirstName.length || 0) + (clientLastName.length || 0);
      }
      let testimonialTitle = "Another Success Story . . .";
      if (mlsAreaID === "ALA-2619I") {
        testimonialTitle = "A Client's Experience . . .";
      } else if (mlsAreaID === "SCL-13A") {
        testimonialTitle = "";
      }
      return (
        <div className={`${rootClassName} ${testimonialContainerStyles || ""}`}>
          {showButton && (
            <Link
              to="/agent/clienttestimonials"
              className="af-column-testimonial-edit-page-button"
            >
              <div>Edit Testimonial</div>
            </Link>
          )}

          <div className="af-column-testimonial-text-container">
            <div className="af-column-testimonial-title">
              {testimonialTitle}
            </div>

            <div
              className={`af-column-testimonial-content-row ${testimonialContentRowStyles}`}
            >
              {listgenUserID === "102843" && (
                <div className="af-column-testimonial-quotation af-column-testimonial-start-quote">
                  "
                </div>
              )}
              {listgenUserID === "102843" ? (
                <div
                  className={`af-column-testimonial-text ${testimonialTextStyles}`}
                >
                  I have nothing but praise for Michael Galli and his excellent
                  team. They are{" "}
                  <strong> thorough, attentive, efficient and prompt</strong>
                  —all things that you want when you are planning to buy or sell
                  your house.
                </div>
              ) : (
                <div
                  className={`af-column-testimonial-text ${testimonialTextStyles}`}
                >
                  {testimonialContent}{" "}
                </div>
              )}
              {listgenUserID === "102843" && (
                <div className="af-column-testimonial-quotation af-column-testimonial-end-quote">
                  "
                </div>
              )}
            </div>
            {clientFirstName && (
              <div
                className={`af-column-testimonial-signoff ${
                  clientNameLength > 42 &&
                  "af-column-testimonial-shorter-margin-signoff"
                } ${testimonialTextStyles} ${signoffStyles}`}
              >
                ~ {clientFirstName} {clientLastName}
              </div>
            )}
          </div>
        </div>
      );
    }
  }
}

export default AFColumnTestimonial;
